<mat-checkbox [checked]="checked()" [indeterminate]="indeterminate()" [disabled]="disabled()" (change)="onChange($event)"> </mat-checkbox>
